export enum REBOOT_STATE {
  NONE = 'NONE',
  ERROR = 'ERROR',
  PROGRESS = 'PROGRESS',
  SUCCESS = 'SUCCESS'
}
